import logger from "@next/core-logger"
import {IncomingHttpHeaders} from "http"
import type {AxiosError} from "axios"
import axios from "../../utils/axios"

import {ExternalSearchApiResponse, GenericSearchResponse} from "../../models/searchApi"
import {BloomreachCookiesInitialVal} from "../../models/SearchState"
import ProductsApi from "../../config/api/products"
import build from "../../utils/buildProductsRequestParams"
import {SearchApiRequestTypes, PAGE_LOAD_TRIGGER} from "../../config/constants"
import {httpUrlTrimmer} from "../../utils/httpUrlTrimmer"
import {devboxUrlTrimmer} from "../../utils/devboxUrlTrimmer"

interface getProductsParameters {
    headers: IncomingHttpHeaders
    url: string
    searchTerm: string | null
    type: SearchApiRequestTypes
    bloomreachCookiesInitialVal: BloomreachCookiesInitialVal
    bloomreachPersonalizationEnabled: boolean
    pageSize?: number
    fields?: (keyof ExternalSearchApiResponse)[]
    start: number
    sliceSize: number
    bloomreachDefaultProviderArgs: string
}
// this will always be called server-side on first render and subsequent server-side renders
export const getProducts = async ({
    headers,
    url,
    searchTerm,
    type,
    bloomreachCookiesInitialVal,
    bloomreachPersonalizationEnabled,
    pageSize = 24,
    fields,
    start,
    sliceSize,
    bloomreachDefaultProviderArgs,
}: getProductsParameters): Promise<GenericSearchResponse> => {
    try {
        const getProductsApi = ProductsApi("getProducts")

        const urlTrimmed = devboxUrlTrimmer(httpUrlTrimmer(url))
        const response = await axios({
            method: getProductsApi.method,
            url: `${getProductsApi.localEndpoint()}`,
            headers: headers as {
                [header: string]: string
            },
            params: build({
                url: urlTrimmed,
                searchTerm,
                type,
                pageSize,
                bloomreachCookiesInitialVal,
                bloomreachPersonalizationEnabled,
                pageLoadTrigger: PAGE_LOAD_TRIGGER.nextPage,
                fields,
                start,
                sliceSize,
                bloomreachDefaultProviderArgs,
            }),
        })
        return response.data as GenericSearchResponse
    } catch (error) {
        const ex = error as AxiosError
        if (ex.response) {
            // Axios interceptors log this error already
            throw ex
        }
        logger.error(ex)
        throw ex
    }
}
